import React from 'react';
import EmployeesPasswordModalView from './EmployeesPasswordModalView';
import AccessControl from '../../shared/user/AccessControl';

export default ({ roles }) => {
  const requiredRoles = ['ROLE_MANAGER'].concat(roles);
  const hasAllRoles = new AccessControl().hasAllRoles(requiredRoles);
  return hasAllRoles && <EmployeesPasswordModalView />;
};
